/* eslint-disable import/extensions */
import * as React from 'react';
import { EGDSLayoutFlex, EGDSLayoutFlexItem } from '@egds/react-core/layout-flex';
import { useLocation } from 'react-router-dom';
import { ErrorBoundary } from 'bernie-view';
import { Experiment, ExperimentControl, ExperimentVariant } from '@shared-ui/experiment-context';
import { useLocalization } from '@shared-ui/localization-context';
import { ReferrerContextProvider } from './infosite-referrer-context';
import { SharedUiDateFieldWrapper, SharedUiTravelersWrapper } from './field-wrappers';
import { SharedUiFormWrapper } from './form-wrapper';
import { SharedUiSingleOfferSearchButtonWrapper } from 'components/infosite/shared-ui/offers/single-offer-search-button-wrapper';
import { SharedUiTravelersSelectorWrapper } from '../offers/shared-ui-traveler-selector-wrapper';
const DatedForm = ({
  l10nKey
}) => {
  const {
    formatText
  } = useLocalization();
  return React.createElement(EGDSLayoutFlex, {
    space: "three"
  }, React.createElement(EGDSLayoutFlexItem, {
    grow: 4
  }, React.createElement("div", null, React.createElement(SharedUiDateFieldWrapper, {
    buttonText: formatText(l10nKey)
  }))), React.createElement(EGDSLayoutFlexItem, {
    grow: 3
  }, React.createElement("div", null, React.createElement(Experiment, {
    name: "Vrbex_traveler_selector"
  }, React.createElement(ExperimentControl, null, React.createElement(SharedUiTravelersWrapper, {
    closeOnSubmit: false
  })), React.createElement(ExperimentVariant, {
    bucket: 1
  }, React.createElement(SharedUiTravelersSelectorWrapper, null))))));
};
export const SharedUiDatedForm = ({
  onChange
}) => {
  const location = useLocation();
  return React.createElement(ErrorBoundary, {
    label: "shared-ui-dated-form"
  }, React.createElement(ReferrerContextProvider, null, React.createElement(SharedUiFormWrapper, {
    action: location.pathname,
    onChange: onChange
  }, React.createElement(DatedForm, {
    l10nKey: 'hotels.infosite.searchForm.availabilityButton.label'
  }))));
};
SharedUiDatedForm.displayName = 'SharedUiDatedForm';
export const SharedUiSingleUnitForm = ({
  onChange,
  onSubmit
}) => {
  const location = useLocation();
  const {
    formatText
  } = useLocalization();
  return React.createElement(ReferrerContextProvider, null, React.createElement(SharedUiFormWrapper, {
    action: location.pathname,
    onChange: onChange,
    onSubmit: onSubmit
  }, React.createElement(EGDSLayoutFlex, {
    direction: "column",
    space: "three"
  }, React.createElement(EGDSLayoutFlexItem, null, React.createElement("div", null, React.createElement(SharedUiDateFieldWrapper, {
    buttonText: formatText('hotels.infosite.searchForm.availabilityButton.label'),
    closeOnSubmit: true
  }))), React.createElement(Experiment, {
    name: "PWA_VR_Get_Single_unit_in_Multi_room_search"
  }, React.createElement(ExperimentControl, null, React.createElement(EGDSLayoutFlexItem, null, React.createElement("div", null, React.createElement(Experiment, {
    name: "Vrbex_traveler_selector"
  }, React.createElement(ExperimentControl, null, React.createElement(SharedUiTravelersWrapper, {
    closeOnSubmit: false,
    isSingleUnit: true
  })), React.createElement(ExperimentVariant, {
    bucket: 1
  }, React.createElement(SharedUiTravelersSelectorWrapper, null)))))), React.createElement(ExperimentVariant, {
    bucket: 1
  })), React.createElement(Experiment, {
    name: "Vrbex_Availability_Date_Selector"
  }, React.createElement(ExperimentControl, null, React.createElement(EGDSLayoutFlexItem, null, React.createElement(SharedUiSingleOfferSearchButtonWrapper, null))), React.createElement(ExperimentVariant, {
    bucket: 1
  }, React.createElement(React.Fragment, null))))));
};
SharedUiSingleUnitForm.displayName = 'SharedUiSingleUnitForm';